abstract class SocketEvent {
  protected abstract props: any;

  public bindProps(props): any {
    this.props = props;
    return this;
  }
}

export { SocketEvent };
